import { HeaderLogo } from './Logo';
import { Nav } from './Nav';
import { MobileNav } from './MobileNav';

interface HeaderProps {
  onProfileClick: () => void;
}

export function Header({ onProfileClick }: HeaderProps) {
  return (
    <>
      <header className="header">
        <HeaderLogo />
        <Nav onProfileClick={onProfileClick} />
      </header>
      <MobileNav onProfileClick={onProfileClick} />
    </>
  );
}
